module.exports = __webpack_public_path__ + "static/media/microgrid.ea7c9d07.svg";